import { PaletteOptions } from '@material-ui/core/styles/createPalette'
import basePalette from './base'

export default {
  ...basePalette,
  type: 'dark',
} as PaletteOptions
